import React, { useState } from "react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import {
  ChartColumn,
  FileChartColumnIncreasing,
  FileText,
  Sparkles,
} from "lucide-react";
import ReportsTab from "./components/ReportsTab";

const AdvancedReports = () => {
  const [selectedReport, setSelectedReport] = useState(null);
  const [generatedReports, setGeneratedReports] = useState([]);

  const analyticsCards = [
    { title: "Employee Overview", category: "People", description: "Comprehensive employee data and demographics", tags: ["Total Employees", "By Department", "By Role", "Tenure Analysis"], icon: "users" },
    { title: "Payroll Summary", category: "Financial", description: "Salary distribution and compensation analysis", tags: ["Total Payroll", "Avg Salary", "Department Costs", "Overtime"], icon: "dollar-sign" },
    { title: "Attendance Report", category: "Operations", description: "Attendance tracking and absence patterns", tags: ["Attendance Rate", "Leave Days", "Absences", "Punctuality"], icon: "clock" },
    { title: "Performance Analytics", category: "People", description: "Performance scores and improvement tracking", tags: ["Avg Score", "Top Performers", "Improvement Rate", "Goals Met"], icon: "trending-up" },
    { title: "Training Progress", category: "Development", description: "Course completion and skill development", tags: ["Courses Completed", "Avg Score", "Certifications", "Hours Spent"], icon: "graduation-cap" },
    { title: "Rewards Impact", category: "Engagement", description: "Recognition and rewards effectiveness", tags: ["Awards Given", "Points Redeemed", "Engagement Score", "ROI"], icon: "award" },
  ];

  const handleDeleteReport = (reportId) => {
    setGeneratedReports((prev) =>
      prev.filter((r) => r.reportId !== reportId)
    );
  };

  const handleGenerateReport = (newReport) => {
    const reportWithStatus = { ...newReport, status: "generating" };

setGeneratedReports((prev) => [reportWithStatus, ...prev]);

    setTimeout(() => {
      setGeneratedReports((prev) =>
        prev.map((r) =>
          r.reportId === reportWithStatus.reportId
            ? { ...r, status: "completed" }
            : r
        )
      );
    }, 1000);
  };

  return (
    <div className="pt-6">
      <div className="grid grid-cols-1">
        <div className="space-y-6">
          <SummaryHeader
            title="Advanced Reports"
            icon={FileChartColumnIncreasing}
            description="Generate custom data-driven insights and analytics"
            color="orange"
          >
            <div className="grid grid-cols-3 gap-4">
              <SummaryItem
                title="Available Templates"
                icon={<FileText />}
                display={analyticsCards.length}
              />
              <SummaryItem
                title="Generated"
                icon={<ChartColumn />}
                display={generatedReports.length}
              />
              <SummaryItem
                title="Categories"
                icon={<Sparkles />}
                display={new Set(analyticsCards.map((c) => c.category)).size}
              />
            </div>
          </SummaryHeader>

          <ReportsTab
            analyticsCards={analyticsCards}
            selectedReport={selectedReport}
            onSelectReport={setSelectedReport}
            onGenerateReport={handleGenerateReport}
            generatedReports={generatedReports}
            onDeleteReport={handleDeleteReport}
          />
        </div>
      </div>
    </div>
  );
};

export default AdvancedReports;
